import { SafeHtml, DomSanitizer } from '@angular/platform-browser';

import { Injectable, Optional } from '@angular/core';
import { eGENA_Checkliste } from '../../visionet/Checkliste';
import { eGENA_KarteireiterTyp } from '../../visionet/KarteireiterTyp';
import { GlobalValues } from './GlobalValues';
import { Platform } from 'ionic-angular';
import { config } from '../../../package.json';

import { GlobalConstants } from './GlobalConstants';


@Injectable()
export class GlobalsSingleton {

	private globalValues : GlobalValues;

	constructor(/*@Optional()*/ globalValues : GlobalValues, platform: Platform, public sanitizer: DomSanitizer) {
		if (!this.globalValues) {
			if (window[GlobalConstants.WINDOW_PROPERTY_GlobalValues]) {
				this.globalValues = window[GlobalConstants.WINDOW_PROPERTY_GlobalValues];
			}
			else {
				this.globalValues = new GlobalValues(true);
				window[GlobalConstants.WINDOW_PROPERTY_GlobalValues] = this.globalValues;
			}
		}

		if (this.globalValues.getDebutMessage() != undefined) {
			this.debugMessages = this.globalValues.getDebutMessage();
		}

		if (this.globalValues.isMobileDevice) {
			
		}			

		if (platform.is("ios"))
			this._isIOS = true;

	}

	private debugMessages:string = "";
	public getDebugMessage() {
		return this.debugMessages;
	}


	private _isIOS = false;
	public isIOS() : boolean {
		return this._isIOS;
	}

	public isPhone() : boolean {
		return this.globalValues.isPhone();
	}


	public getWidth() : number {
		return this.globalValues.getWidth();
	}
	public getHeight() : number {
		return this.globalValues.getHeight();
	}




	public setCurSearchResultChecklists(value : eGENA_Checkliste[]) {
		this.globalValues.setCurSearchResultChecklists(value);
	}
	public getCurSearchResultChecklists() : eGENA_Checkliste[] {
		return this.globalValues.getCurSearchResultChecklists();
	}






	public setAzIndex(value : Map<string, eGENA_Checkliste[]>) {
		this.globalValues.setAzIndex(value);
	}
	public getAzIndex() : Map<string, eGENA_Checkliste[]> {
		return  this.globalValues.getAzIndex();
	}



	public setAbcdeIndex(value : Map<string, eGENA_Checkliste[]>) {
		this.globalValues.setAbcdeIndex(value);
	}
	public getAbcdeIndex() : Map<string, eGENA_Checkliste[]> {
		return  this.globalValues.getAbcdeIndex();
	}



	public setBodynavIndex(value : Map<string, eGENA_Checkliste[]>) {
		this.globalValues.setBodynavIndex(value);
	}
	public getBodynavIndex() : Map<string, eGENA_Checkliste[]> {
		return  this.globalValues.getBodynavIndex();
	}



	public setFuzzySearchIndex(value : eGENA_Checkliste[]) {
		this.globalValues.setFuzzySearchIndex(value);
	}
	public getFuzzySearchIndex() : eGENA_Checkliste[] {
		return  this.globalValues.getFuzzySearchIndex();
	}


	public translate(key : string, ...values: any []) : string {
		return this.globalValues.translate(key, values);
	}

	
	public translateKarteireiter(key : string) : string {
		return this.globalValues.translate("TAB." + key);
	}
	/* Spezialübersetzungen für kleine Mobiltelefone
	 * Karteireiter oben und Karteireiter unten
	 */
	private isTranslated(key : string, translation : string) : boolean {
		return key !== translation;
	}
	public translateKarteireiterPhone(key : string, karteireiterKombination : string, bildschirmbreite : string) : string {
		let specialKey = "TAB." + key + "-" + karteireiterKombination;
		let translation : string; 
		if (bildschirmbreite !== "") {
			translation = this.globalValues.translate(specialKey + "-" + bildschirmbreite);
//console.log("translateKarteireiterPhone('')");
			if (this.isTranslated(specialKey + "-" + bildschirmbreite, translation))
				return translation
		}

		translation = this.globalValues.translate(specialKey);
		if (this.isTranslated(specialKey, translation))
			return translation

		return this.globalValues.translate("TAB." + key);
	}




	public translateHTML(key : string, ...values: any []) : SafeHtml {
		let html : SafeHtml = this.globalValues.translate(key, values).replace(/\n/g, "<br/>");
		console.log("'" + key +"' --> HTML '" + html);
		return html
	}

}


// WEBPACK FOOTER //
// ./src/app/core/GlobalsSingleton.ts